// Check if email address has valid format
export function is_valid_mail( mail ){
	var regex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
	
	return regex.test( mail ) == true;
}


// Clean VAT whitespaces and punctoation
export function clean_vat( vat ) {
	return vat.replace(/[^a-z0-9]/gi, '').toUpperCase();
}


// Check if VAT number has valid format
export function is_valid_vat( vat ) {
	var vat = clean_vat( vat );

	// EU Country regexes
	var vat_regexes = [
		'(AT)U[0-9]{8}', 											// Austria
		'(BE)0[0-9]{9}', 											// Belgium
		'(BG)[0-9]{9,10}', 											// Bulgaria
		'(CY)[0-9]{8}[A-Z]', 											// Cyprus
		'(CZ)[0-9]{8,10}', 											// Czech Republic
		'(DE)[0-9]{9}', 											// Germany
		'(DK)[0-9]{8}', 											// Denmark
		'(EE)[0-9]{9}', 											// Estonia
		'(EL|GR)[0-9]{9}', 											// Greece
		'(ES)[0-9A-Z][0-9]{7}[0-9A-Z]', 							// Spain
		'(FI)[0-9]{8}', 											// Finland
		'(FR)[0-9A-Z]{2}[0-9]{9}', 									// France
		'(GB)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})?', 				// United Kingdom
		'(HR)[0-9]{11}', 											// Croatia
		'(HU)[0-9]{8}', 											// Hungary
		'(IE)[0-9][0-9A-Z\+\*][0-9]{5}[A-Z]{1,2}',						// Ireland
		'(IT)[0-9]{11}', 											// Italy
		'(LT)([0-9]{9}|[0-9]{12})', 								// Lithuania
		'(LU)[0-9]{8}', 											// Luxembourg
		'(LV)[0-9]{11}', 											// Latvia
		'(MT)[0-9]{8}', 											// Malta
		'(NL)[0-9]{9}B[0-9]{2}', 									// Netherlands
		'(PL)[0-9]{10}', 											// Poland
		'(PT)[0-9]{9}', 											// Portugal
		'(RO)[0-9]{2,10}', 											// Romania
		'(SE)[0-9]{12}', 											// Sweden
		'(SI)[0-9]{8}', 											// Slovenia
		'(SK)[0-9]{10}' 											// Slovakia
	];

	var regex = new RegExp( '^(' + vat_regexes.join('|') + ')$', 'gi' );

	return regex.test( vat ) == true;
}

export function is_valid_full_name( full_name ) {
	var re = /^\S+( \S+)+$/;

	return re.test( full_name );
}


// VAT Tests
/*
// Country: AT-Austria
console.log( 'Country: AT-Austria' );
console.log( 'ATU99999999 -- ' + is_valid_vat( 'ATU99999999' ) );
console.log( '---------------------------------------' );

// Country: BE-Belgium
console.log( 'Country: BE-Belgium' );
console.log( 'BE0999999999 -- ' + is_valid_vat( 'BE0999999999' ) );
console.log( '---------------------------------------' );

// Country: BG-Bulgaria
console.log( 'Country: BG-Bulgaria' );
console.log( 'BG999999999 -- ' + is_valid_vat( 'BG999999999' ) );
console.log( 'BG9999999999 -- ' + is_valid_vat( 'BG9999999999' ) );
console.log( '---------------------------------------' );

// Country: CY-Cyprus
console.log( 'Country: CY-Cyprus' );
console.log( 'CY99999999L -- ' + is_valid_vat( 'CY99999999L' ) );
console.log( '---------------------------------------' );

// Country: CZ-Czech Republic
console.log( 'Country: CZ-Czech Republic' );
console.log( 'CZ99999999 -- ' + is_valid_vat( 'CZ99999999' ) );
console.log( 'CZ999999999 -- ' + is_valid_vat( 'CZ999999999' ) );
console.log( 'CZ9999999999 -- ' + is_valid_vat( 'CZ9999999999' ) );
console.log( '---------------------------------------' );

// Country: DE-Germany
console.log( 'Country: DE-Germany' );
console.log( 'DE999999999 -- ' + is_valid_vat( 'DE999999999' ) );
console.log( '---------------------------------------' );

// Country: DK-Denmark
console.log( 'Country: DK-Denmark' );
console.log( 'DK99 99 99 99 -- ' + is_valid_vat( 'DK99 99 99 99' ) );
console.log( '---------------------------------------' );

// Country: EE-Estonia
console.log( 'Country: EE-Estonia' );
console.log( 'EE999999999 -- ' + is_valid_vat( 'EE999999999' ) );
console.log( '---------------------------------------' );

// Country: EL-Greece
console.log( 'Country: EL-Greece' );
console.log( 'EL999999999 -- ' + is_valid_vat( 'EL999999999' ) );
console.log( '---------------------------------------' );

// Country: ES-Spain
console.log( 'Country: ES-Spain' );
console.log( 'ESX9999999X -- ' + is_valid_vat( 'ESX9999999X' ) );
console.log( '---------------------------------------' );

// Country: FI-Finland
console.log( 'Country: FI-Finland' );
console.log( 'FI99999999 -- ' + is_valid_vat( 'FI99999999' ) );
console.log( '---------------------------------------' );

// Country: FR-France 
console.log( 'Country: FR-France' );
console.log( 'FRXX 999999999 -- ' + is_valid_vat( 'FRXX 999999999' ) );
console.log( '---------------------------------------' );

// Country: GB-United Kingdom
console.log( 'Country: GB-United Kingdom' );
console.log( 'GB999 9999 99 -- ' + is_valid_vat( 'GB999 9999 99' ) );
console.log( 'GB999 9999 99 999 -- ' + is_valid_vat( 'GB999 9999 99 999' ) );
console.log( 'GBGD999 -- ' + is_valid_vat( 'GBGD999' ) );
console.log( 'GBHA999 -- ' + is_valid_vat( 'GBHA999' ) );
console.log( '---------------------------------------' );

// Country: HR-Croatia
console.log( 'Country: HR-Croatia' );
console.log( 'HR99999999999 -- ' + is_valid_vat( 'HR99999999999' ) );
console.log( '---------------------------------------' );

// Country: HU-Hungary
console.log( 'Country: HU-Hungary' );
console.log( 'HU99999999 -- ' + is_valid_vat( 'HU99999999' ) );
console.log( '---------------------------------------' );

// Country: IE-Ireland
console.log( 'Country: IE-Ireland' );
console.log( 'IE9S99999L -- ' + is_valid_vat( 'IE9S99999L' ) );
console.log( 'IE9999999WI -- ' + is_valid_vat( 'IE9999999WI' ) );
console.log( '---------------------------------------' );

// Country: IT-Italy
console.log( 'Country: IT-Italy' );
console.log( 'IT99999999999 -- ' + is_valid_vat( 'IT99999999999' ) );
console.log( '---------------------------------------' );

// Country: LT-Lithuania
console.log( 'Country: LT-Lithuania' );
console.log( 'LT999999999 -- ' + is_valid_vat( 'LT999999999' ) );
console.log( 'LT999999999999 -- ' + is_valid_vat( 'LT999999999999' ) );
console.log( '---------------------------------------' );

// Country: LU-Luxembourg
console.log( 'Country: LU-Luxembourg' );
console.log( 'LU99999999 -- ' + is_valid_vat( 'LU99999999' ) );
console.log( '---------------------------------------' );

// Country: LV-Latvia
console.log( 'Country: LV-Latvia' );
console.log( 'LV99999999999 -- ' + is_valid_vat( 'LV99999999999' ) );
console.log( '---------------------------------------' );

// Country: MT-Malta
console.log( 'Country: MT-Malta' );
console.log( 'MT99999999 -- ' + is_valid_vat( 'MT99999999' ) );
console.log( '---------------------------------------' );

// Country: NL-The Netherlands
console.log( 'Country: NL-The Netherlands' );
console.log( 'NL999999999B99 -- ' + is_valid_vat( 'NL999999999B99' ) );
console.log( '---------------------------------------' );

// Country: PL-Poland
console.log( 'Country: PL-Poland' );
console.log( 'PL9999999999 -- ' + is_valid_vat( 'PL9999999999' ) );
console.log( '---------------------------------------' );

// Country: PT-Portugal
console.log( 'Country: PT-Portugal' );
console.log( 'PT999999999 -- ' + is_valid_vat( 'PT999999999' ) );
console.log( '---------------------------------------' );

// Country: RO-Romania
console.log( 'Country: RO-Romania' );
console.log( 'RO999999999 -- ' + is_valid_vat( 'RO999999999' ) );
console.log( '---------------------------------------' );

// Country: SE-Sweden
console.log( 'Country: SE-Sweden' );
console.log( 'SE999999999999 -- ' + is_valid_vat( 'SE999999999999' ) );
console.log( '---------------------------------------' );

// Country: SE-Sweden
console.log( 'Country: SI-Slovenia' );
console.log( 'SI99999999 -- ' + is_valid_vat( 'SI99999999' ) );
console.log( '---------------------------------------' );

// Country: SK-Slovakia
console.log( 'Country: SK-Slovakia' );
console.log( 'SK9999999999 -- ' + is_valid_vat( 'SK9999999999' ) );
console.log( '---------------------------------------' );
*/
